import { useTheme } from '@chronosphereio/chrono-ui';
import { ChartsProvider, ChartsTheme, EChartsTheme, generateChartsTheme } from '@chronosphereio/viz-framework';
import React, { useMemo } from 'react';

// TODO: remove overrides and generate theme approach
const ECHARTS_THEME_OVERRIDES: EChartsTheme = {};

export interface CloudChartsProviderProps {
  children: React.ReactNode;
  tooltipContainer?: string;
}

export function CloudChartsProvider({ children, tooltipContainer = 'tooltipPortalId' }: CloudChartsProviderProps) {
  const muiTheme = useTheme();
  const chartsTheme: ChartsTheme = useMemo(() => {
    return generateChartsTheme(muiTheme.theme, ECHARTS_THEME_OVERRIDES, `[data-id='${tooltipContainer}']`);
  }, [muiTheme.theme, tooltipContainer]);

  return (
    <ChartsProvider chartsTheme={chartsTheme} enablePinning={true}>
      {children}
    </ChartsProvider>
  );
}
